export default __webpack_public_path__ + "static/media/ic_arrow_right.d23fcb6a.svg";